/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* トップページカテゴリーアコーディオン */

$(function() {
  $(".CatAco-ShowMore").click(function() {
    var show_cat = $(this)
      .parent(".CatAco-Wrapper")
      .find(".CategoryList");
    var small_height = 90;
    var original_height = show_cat.css({ height: "auto" }).height();

    if (show_cat.hasClass("CatAco-Open")) {
      /*CLOSE*/
      show_cat.height(original_height).animate({ height: small_height }, 300);
      show_cat.removeClass("CatAco-Open");
      $(this)
        .text("+　続きを見る")
        .removeClass("CatAco-Active");
    } else {
      /*CatAco-Open*/
      show_cat
        .height(small_height)
        .animate({ height: original_height }, 300, function() {
          show_cat.height("auto");
        });
      show_cat.addClass("CatAco-Open");
      $(this)
        .text("-　閉じる")
        .addClass("CatAco-Active");
    }
  });
});

/* モーダルウィンドウ(fancybox) */

$(function(){
	$('.FancyBoxTab').each(function(i){
		$(this).find('.FancyBoxTab_button').attr('data-src','#fbtab' + (i+1));
		$(this).find('.modal').attr('id','fbtab' + (i+1));
	});
});

/* 工程セクション ナンバリング */

$(function(){
	$('.CustomProcessNum').each(function(i){
		$(this).prepend((i+1));
	});
});

/* ymqアプリ表示位置変更 */

$(function() {
    $('#ymq-box').insertAfter('.ProductMeta');
});

/*-------------------------------------------
　瞳制作：下記membership form用
--------------------------------------------*/

if (typeof memloadedPlanButtonJS === 'undefined') {
    var memloadedPlanButtonJS = true;
    var $jQ224;
    bold_memberships_load_script = function (url, callback) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
        if(callback){
            script.onload=callback;
        }
    };

    bold_memberships_load_style = function(url) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        document.getElementsByTagName('head')[0].appendChild(link);
    };

    load_bootstrap_script = function() {
        bold_memberships_load_script('https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js',  loadWidget);
    };

    load_validator_script = function() {
        bold_memberships_load_script('https://ajax.aspnetcdn.com/ajax/jquery.validate/1.14.0/jquery.validate.min.js', load_bootstrap_script);
    };

    /**
     * Ticket: MEM-573
     * Removed the conditional loading if jquery exists. Force our version and then no conflict onto it.
     * https://api.jquery.com/jquery.noconflict/
     */
    bold_memberships_load_script('https://cdnjs.cloudflare.com/ajax/libs/jquery/2.2.4/jquery.min.js', load_validator_script);
    bold_memberships_load_script('https://js.stripe.com/v3');

    var current_src = document.currentScript.src;
    var styles_src = current_src.replace('js/plan_multibutton.js', 'css/stripe-form.css');

    bold_memberships_load_style(styles_src);

    if (!window.StripeCheckout) {
        bold_memberships_load_script('https://checkout.stripe.com/checkout.js');
    }

    function loadWidget() {
      $jQ224 = jQuery.noConflict(true);

      $jQ224(document).ready(function () {

            createButton = function (buttonData) {
                var domain = typeof buttonData.domain === 'undefined' ? '' : buttonData.domain;
                return $jQ224('<a href="#" class="btn membuttonclick" id="membership_button_' + buttonData.billingid + '" data-billingid="' + buttonData.billingid + '" data-planid="' + buttonData.planid + '" data-approot="' + buttonData.approot + '" data-hash="' + buttonData.hash + '" data-domain="' + domain + '" data-enable-email-verification="' + buttonData.enableEmailVerification + '" >' + buttonData.label + '</a>');
            };

            createModal = function (modalData) {
                if ($jQ224('#memmodal').length) {
                    $jQ224("#memmodal").remove();
                }

                var domain = typeof modalData.domain === 'undefined' ? '' : modalData.domain;
                var enableEmailVerification = '';
                if(modalData.enableEmailVerification === "1"){
                    enableEmailVerification = '<label for="bold-mem-validate-email-' + modalData.billingid + '" id="lang_email_' + modalData.billingid + '">メールアドレスの確認:</label><input type="text" name="validate_email" class="form-inputs required email customerData" id="bold-mem-validate-email-' + modalData.billingid + '"></div>';
                }
                $jQ224("body").append('<div id="memmodal"></div>');
                var modalForm = $jQ224('<form id="formbutton' + modalData.billingid + '" data-billingid="' + modalData.billingid + '" data-planid="' + modalData.planid + '" data-approot="' + modalData.approot + '" data-domain="' + domain +'" data-enable-email-verification="' + modalData.enableEmailVerification + '" >' +
                    '<div class="modal fade" id="bold-mem-modal-' + modalData.billingid + '" tabindex="-1" role="dialog" aria-hidden="true">' +
                    '<div class="modal-dialog">' +
                    '<div class="modal-content" id="bold-mem-modal-loading-' + modalData.billingid + '" style="display:none;padding:1em;text-align:center;">' +
                    '<span id="lang_loading_msg_' + modalData.billingid + '">Please wait...</span>' +
                    '</div>' +
                    '<div class="modal-content" id="bold-mem-modal-content-' + modalData.billingid + '">' +
                    '<div class="modal-header">' +
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                                       '<h4 class="modal-title" id="modalPlanName" style="color:#800000;"></h4></div>' +
                    '<div class="modal-body">' +
/*                    '<span id="lang_create_account_msg_' + modalData.billingid + '"></span><span>情報を登録</span>' + */
                    
                    '<div class="bold-form-group-modal form-group customerData">' +
                    '<label for="bold-mem-last-name-' + modalData.billingid + '" id="lang_last_name_' + modalData.billingid + '">Last Name:</label>' +
                    '<input type="text" name="lastname" class="form-inputs required customerData" id="bold-mem-last-name-' + modalData.billingid + '"></div>' +

                    '<div class="bold-form-group-modal form-group customerData">' +
                    '<label for="bold-mem-first-name-' + modalData.billingid + '" id="lang_first_name_' + modalData.billingid + '">First Name:</label>' +
                    '<input type="text" name="firstname" class="form-inputs required customerData" id="bold-mem-first-name-' + modalData.billingid + '"></div>' +

                    '<div class="bold-form-group-modal form-group customerData">' +
                    '<label for="bold-mem-email-' + modalData.billingid + '" id="lang_email_' + modalData.billingid + '">Email:</label>' +
                    '<input type="text" name="email" class="form-inputs required email customerData" id="bold-mem-email-' + modalData.billingid + '">' +
                    enableEmailVerification +
                    '</div>' +
                    '<div class="bold-form-group-modal form-group" id="customFields"></div>' +
                    '<div class="bold-form-group-modal form-group subscription">' +
                    '<label for="bold-mem-address1-' + modalData.billingid + '" id="lang_address1_' + modalData.billingid + '">Address1:</label>' +
                    '<input type="text" name="address1" class="form-inputs required address1 subscription" id="bold-mem-address1-' + modalData.billingid + '"></div>' +
                    '<div class="bold-form-group-modal form-group subscription">' +
                    '<label for="bold-mem-address2-' + modalData.billingid + '" id="lang_address2_' + modalData.billingid + '">Address2:</label>' +
                    '<input type="text" name="address2" class="form-inputs address2 subscription" id="bold-mem-address2-' + modalData.billingid + '"></div>' +
                    '<div class="bold-form-group-modal form-group subscription">' +
                    '<label for="bold-mem-city-' + modalData.billingid + '" id="lang_city_' + modalData.billingid + '">City:</label>' +
                    '<input type="text" name="city" class="form-inputs required city subscription" id="bold-mem-city-' + modalData.billingid + '"></div>' +
                    '<div class="bold-form-group-modal form-group subscription">' +
                    '<label for="bold-mem-zip-' + modalData.billingid + '" id="lang_zip_' + modalData.billingid + '">Zip:</label>' +
                    '<input type="text" name="zip" class="form-inputs required zip subscription" id="bold-mem-zip-' + modalData.billingid + '"></div>' +
                    '<div class="bold-form-group-modal form-group subscription">' +
                    '<label for="bold-mem-country-' + modalData.billingid + '" id="lang_country_' + modalData.billingid + '">Country:</label>' +
                    '<select class="form-inputs country required subscription" id="shippingCountry" name="n_country" onchange="updateProvince()"><option value="">--</option></select></div>' +
                    '<div class="bold-form-group-modal form-group subscription">' +
                    '<label for="bold-mem-province-' + modalData.billingid + '" id="lang_province_' + modalData.billingid + '">Province:</label>' +
                    '<select id="shippingProvince" class="form-inputs province required subscription" name="n_province"><option value="">--</option></select></div>' +
                    '<div class="subscription" id="modalSubscriptionBoxInfo"></div>' +
                    '<label id="bold-mem-email-manual-error" class="text-danger" style="color: #cc0000;font-weight: bold;"></label>' +
                    '<div class="modal-footer">' +
                    '<button type="button" id="lang_cancel_' + modalData.billingid + '" class="btn btn-bold-secondary" data-dismiss="modal">Cancel</button>' +
                    '<button style="display:none" data-gateway="stripe" data-gateway-id="2" class="btn btn-bold-main boldmemsaveaccount" id="boldMemSaveAccountStripe' + modalData.billingid + '">Pay with Card</button>' +
                    '<button style="display:none" data-gateway="paypal" data-gateway-id="1" class="btn btn-bold-main boldmemsaveaccount" id="boldMemSaveAccountPayPal' + modalData.billingid + '">Pay with PayPal</button>' +
                    '<button style="display:none" data-gateway="free" data-gateway-id="0" class="btn btn-bold-main boldmemsaveaccount" id="boldMemSaveAccountFree' + modalData.billingid + '">Join For Free</button>' +
                    '</div></div></div></div>' +
                    '</form>');

                $jQ224('#memmodal').append(modalForm);
            };


            $jQ224('.memberships_button').each(function () {
                var memButton = createButton($jQ224(this).data());
                $jQ224('#checkout_' + $jQ224(this).attr('data-billingid')).append(memButton);
            });


            $jQ224('.membuttonclick').click(function (e) {
                e.preventDefault();

                var billingid = $jQ224(this).attr("data-billingid"),
                    approot = $jQ224(this).attr("data-approot"),
                    hash = $jQ224(this).attr("data-hash"),
                    planid = $jQ224(this).attr("data-planid"),
                    domain = $jQ224(this).attr('data-domain'),
                    enableEmailVerification = $jQ224(this).attr('data-enable-email-verification'),
                    subscriptionBox = 0,
                    customerId = null,
                    questions = [],
                    answers = [],
                    countries = [];

                var stripeHandler = null;
                var stripe = null;
                var stripeSCAFlag = false;
                var billingOptionName = '';

                createModal({billingid: billingid, planid: planid, approot: approot, domain: domain, enableEmailVerification: enableEmailVerification});

                $jQ224.post(approot + '/front_end/purchase/checkSubscription', {
                    'id': planid,
                    'bid': billingid,
                    'hash': hash,
                    'domain': domain
                }, function (response) {
                    if(response === 'Application uninstalled') {
                        $jQ224('a[class="btn membuttonclick"]').attr('disabled', 'true');
                        $jQ224('a[class="btn membuttonclick"]').remove();
                        $jQ224("body").append('<div id="bold-app-uninstalled" style="text-align:center;"><h4>Membership Uninstalled. Please contact store owner</h4></div>');
                        return;
                    }
                    if (typeof response.data.stripe_sca_flag !== 'undefined' && response.data.stripe_sca_flag) {
                        stripeSCAFlag = response.data.stripe_sca_flag;
                    }

                    if (response.success) {

var rdb_name = response.data.billing_option_name;
if(rdb_name=="¥0 Monthly"){ rdb_name = 'お試し（ご懇志制）';}
else if(rdb_name=="¥1,100 Monthly"){ rdb_name = '1100円/月';}
else if(rdb_name=="¥2,200 Monthly"){ rdb_name = '2200円/月';}
else if(rdb_name=="¥3,300 Monthly"){ rdb_name = '3300円/月';}
else { rdb_name = '';}

                   
                        $jQ224('#modalPlanName').html(response.data.plan.name + ' - ' + rdb_name);
                        billingOptionName = response.data.billing_option_name;
                        if (response.data.plan.subscriptionBox == "1") {
                            subscriptionBox = 1;
                            $jQ224('#modalSubscriptionBoxInfo').html(response.data.plan.subscriptionBoxInfo);
                            $jQ224('#shippingCountry').html('<option value="">--</option>');
                            countries = response.data.countries;
                            $jQ224.each(countries, function (key, value) {
                                $jQ224('#shippingCountry').append('<option data-code="' + value['code'] + '" data-id="' + key + '" value="' + value['id'] + '">' + value['name'] + '</option>');
                            });
                        }


                        if (response.data.customFields.length > 0) {
                            $jQ224('#customFields').html('');
                            $jQ224.each(response.data.customFields, function (key, value) {
                                if (value['deprecated'] != 1) {
                                    var el = $jQ224('<div class="form-group" style="margin-top:20px;"><label>' + value['name'] + '</label></div>');

                                    if (value['type'] == "1") {
                                        var formEl = $jQ224('<textarea></textarea>');
                                    } else {
                                        var formEl = $jQ224('<input type="text" />');
                                    }

                                    formEl.attr('value_id', value['id']).attr('name', 'n_' + value['id']);

                                    if (value['required'] == 1) {
                                        formEl.addClass('form-inputs answer required');
                                    } else {
                                        formEl.addClass('form-inputs answer');
                                    }
                                    el.append(formEl);
                                    $jQ224('#customFields').append(el);
                                }
                            });
                        }

                        customerId = $jQ224('.bold_customer_id').text();
                        $jQ224('#bold-mem-modal-' + billingid).modal('show');
                        if ($jQ224('.bold_customer_id').length) {
                            $jQ224('.customerData').hide();
                            $jQ224('.bold-mem-createaccount-intro').hide();
                        } else {
                            $jQ224('.customerData').show();
                        }

                        if (subscriptionBox == "1") {
                            $jQ224('.subscription').show();
                        } else {
                            $jQ224('.subscription').hide();
                        }

                        if (typeof response.data.lang !== 'undefined') {
                            $jQ224.each(response.data.lang, function (key, value) {
                                $jQ224('#lang_' + key + '_' + billingid).text(value != null ? value : '');
                            });


                            $jQ224('#boldMemSaveAccountFree' + billingid).text(response.data.lang.join_btn_free);
                            $jQ224('#boldMemSaveAccountPayPal' + billingid).text(response.data.lang.join_btn_paypal);
                            $jQ224('#boldMemSaveAccountStripe' + billingid).text(response.data.lang.join_btn_stripe);
                        }


                        if (response.data.stripe_pk) {
                            var stripeBtn = $jQ224('#boldMemSaveAccountStripe' + billingid);

                            if (stripeSCAFlag) {
                                stripe = Stripe(response.data.stripe_pk);
                            } else {
                                stripeHandler = StripeCheckout.configure({
                                    panelLabel: 'Subscribe',
                                    allowRememberMe: 'false',
                                    key: response.data.stripe_pk
                                });
                            }
                            stripeBtn.attr('data-gateway-loaded', 1);
                        }

                        if (response.data.paypal) {
                            paypalEnabled = true;
                            $jQ224('#boldMemSaveAccountPayPal' + billingid).attr('data-gateway-loaded', 1);
                        }

                        if (response.data.price == 0) {
                            $jQ224('#boldMemSaveAccountFree' + billingid).show();
                            $jQ224('#boldMemSaveAccountStripe' + billingid).hide();
                            $jQ224('#boldMemSaveAccountPayPal' + billingid).hide();
                        } else if (response.data.price < 50) {
                            $jQ224('#boldMemSaveAccountFree' + billingid).show();
                            $jQ224('#boldMemSaveAccountStripe' + billingid).hide();
                            showGatewayButton($jQ224('#boldMemSaveAccountPayPal' + billingid));
                        } else {
                            $jQ224('#boldMemSaveAccountFree' + billingid).hide();
                            showGatewayButton($jQ224('#boldMemSaveAccountStripe' + billingid));
                            showGatewayButton($jQ224('#boldMemSaveAccountPayPal' + billingid));
                        }

                    } else {
                        alert(response.error);
                    }
                });


                $jQ224('.boldmemsaveaccount').on('click', function (e) {
                    var enableEnableVerification = $jQ224(this).closest("form").attr('data-enable-email-verification');
                    if (enableEnableVerification == "1") {
                        var email = $jQ224(this).closest("form").find('input[name="email"]').val();
                        var confirmEmail = $jQ224(this).closest("form").find('input[name="validate_email"]').val();
                        if (email != confirmEmail) {
                            alert('Emails do not match. Please try again');
                            e.preventDefault();
                        }
                    }

                    var billingId = $jQ224(this).closest("form").attr('data-billingid');
                    var planId = $jQ224(this).closest("form").attr('data-planid');
                    var appRoot = $jQ224(this).closest("form").attr('data-appRoot');
                    var button = this;

                    var gateway = $jQ224(this).attr('data-gateway');
                    var gateway_id = $jQ224(this).attr('data-gateway-id');

                    var form = $jQ224(this).closest('form');
                    form.attr('data-gateway', gateway);
                    form.attr('data-gateway-id', gateway_id);

                    $jQ224('#formbutton' + billingId).validate({
                        errorClass: "my-error-class",
                        submitHandler: function (form) {
                            var $form = $jQ224(form);

                            var gateway = $form.attr('data-gateway');
                            var gateway_id = $form.attr('data-gateway-id');

                            $jQ224('#customFields').find('.answer').each(function () {
                                questions.push($jQ224(this).attr('value_id'));
                                answers.push($jQ224(this).val());
                            });

                            var postData = {
                                'billing_id': billingId,
                                'plan_id': planId,
                                'questions': questions,
                                'answers': answers,
                                'domain': domain
                            };
                            postData.gateway_data = {id: gateway_id};

                            if ($jQ224('.bold_customer_id').length) {
                                postData.customer_id = parseInt(customerId);
                            } else {
                                postData.first_name = $jQ224('#bold-mem-first-name-' + billingId).val();
                                postData.last_name = $jQ224('#bold-mem-last-name-' + billingId).val();
                                postData.email = $jQ224('#bold-mem-email-' + billingId).val();
                            }

                            if (subscriptionBox == 1) {
                                postData.address = {
                                    'address1': $jQ224('#bold-mem-address1-' + billingId).val(),
                                    'address2': $jQ224('#bold-mem-address2-' + billingId).val(),
                                    'province': $jQ224('#formbutton' + billingId + ' #shippingProvince option:selected').val(),
                                    'country': $jQ224('#formbutton' + billingId + ' #shippingCountry option:selected').val(),
                                    'country_name': $jQ224('#formbutton' + billingId + ' #shippingCountry option:selected').text(),
                                    'country_code': $jQ224('#formbutton' + billingId + ' #shippingCountry option:selected').data('code'),
                                    'zip': $jQ224('#bold-mem-zip-' + billingId).val(),
                                    'city': $jQ224('#bold-mem-city-' + billingId).val()
                                };
                            }

                            var postFn = function () {

                                $jQ224('#boldMemSaveAccountFree' + billingid).prop("disabled", true);
                                $jQ224('#boldMemSaveAccountStripe' + billingid).prop("disabled", true);
                                $jQ224('#boldMemSaveAccountPayPal' + billingid).prop("disabled", true);


                                if (postData.gateway_data.id == 0) {
                                    $jQ224('#boldMemSaveAccountFree' + billingid).attr('value', 'Loading...');
                                } else if (postData.gateway_data.id == 1) {
                                    $jQ224('#boldMemSaveAccountPayPal' + billingid).attr('value', 'Loading...');
                                } else if (postData.gateway_data.id == 2) {
                                    $jQ224('#boldMemSaveAccountStripe' + billingid).attr('value', 'Loading...');
                                }

                                $jQ224.post(appRoot + '/front_end/purchase', postData,
                                    function (response) {
                                        if (response.error) {
                                            $jQ224('#boldMemSaveAccountStripe' + billingid).prop("disabled", false);
                                            $jQ224('#boldMemSaveAccountPayPal' + billingid).prop("disabled", false);
                                            $jQ224('#bold-mem-email-manual-error').html(response.error);
                                        } else {
                                            $jQ224('#bold-mem-modal-content-' + billingId).hide();
                                            $jQ224('#bold-mem-modal-loading-' + billingId).show();
                                            top.location = response.redirect_url;
                                        }
                                    }
                                );
                            };

                            if (stripeSCAFlag) {
                                // Calls stripe.confirmCardSetup
                                // If the card requires authentication Stripe shows a pop-up modal to
                                // prompt the user to enter authentication details without leaving your page.
                                var payWithCard = function (stripe, card, clientSecret) {
                                    loading(true);
                                    stripe.confirmCardSetup(clientSecret, {
                                        payment_method: {
                                            card: card
                                        }
                                    }).then(function (result) {
                                        if (result.error) {
                                            showError(result.error.message);
                                        } else {
                                            postData.gateway_data.stripe_token = result.setupIntent.payment_method;
                                            postFn();
                                        }
                                    });
                                };

                                // Show the customer the error from Stripe if their card fails to charge
                                var showError = function (errorMsgText) {
                                    loading(false);
                                    document.querySelector("#stripe-card-error").classList.remove('hidden');
                                    var errorMsg = document.querySelector("#stripe-card-error");
                                    errorMsg.textContent = errorMsgText;
                                };

                                var loading = function (isLoading) {
                                    if (isLoading) {
                                        // Disable the button and show a spinner
                                        document.querySelector("button").disabled = true;
                                        document.querySelector("#stripe-spinner").classList.remove("hidden");
                                        document.querySelector("#stripe-button-text").classList.add("hidden");
                                    } else {
                                        document.querySelector("button").disabled = false;
                                        document.querySelector("#stripe-spinner").classList.add("hidden");
                                        document.querySelector("#stripe-button-text").classList.remove("hidden");
                                    }
                                };
                            }

                            if (gateway == 'stripe') {
                                if (stripeSCAFlag) {
                                    var planAmount = $jQ224('#modalPlanName').text();

                                    if(!email || email == "undefined") {
                                        email = $jQ224(".modal-body").closest("form").find('input[name="email"]').val();
                                    } else {
                                        email = "";
                                    }

                                    var stripeOverlay = '<div id="stripe-overlay">' +
                                        '<form id="stripe-payment-form">\n' +
                                        '<div class="subscription-information">' +
                                        '<svg id="stripe-close" class="bv-icon__icon" viewBox="0 0 20 40"> <path classname="bv-icon__path" fill="grey" d="M11.5,10.3786797 L4.56066017,3.43933983 C3.97487373,2.85355339 3.02512627,2.85355339 2.43933983,3.43933983 C1.85355339,4.02512627 1.85355339,4.97487373 2.43933983,5.56066017 L9.37867966,12.5 L2.43933983,19.4393398 C1.85355339,20.0251263 1.85355339,20.9748737 2.43933983,21.5606602 C3.02512627,22.1464466 3.97487373,22.1464466 4.56066017,21.5606602 L11.5,14.6213203 L18.4393398,21.5606602 C19.0251263,22.1464466 19.9748737,22.1464466 20.5606602,21.5606602 C21.1464466,20.9748737 21.1464466,20.0251263 20.5606602,19.4393398 L13.6213203,12.5 L20.5606602,5.56066017 C21.1464466,4.97487373 21.1464466,4.02512627 20.5606602,3.43933983 C19.9748737,2.85355339 19.0251263,2.85355339 18.4393398,3.43933983 L11.5,10.3786797 Z"></path></svg>' +
                                        '<div id="stripe-plan-amount">' + billingOptionName + ' Subscription</div>' +
                                        '<div id="stripe-email">' + email + '</div>' +
                                        '</div>' +
                                        '<div class="payment-information">' +
                                        '<div id="stripe-card-number-element"><!--Stripe.js injects the Card Element--></div>\n' +
                                        '<div id="stripe-card-expiry-element"><!--Stripe.js injects the Card Element--></div>\n' +
                                        '<div id="stripe-card-cvc-element"><!--Stripe.js injects the Card Element--></div>\n' +
                                        '</div>' +
                                        '<div id="stripe-card-error" class="hidden" role="alert"></div>\n' +
                                        '<div class="action-information">' +
                                        '<button id="stripe-submit">\n' +
                                        '<div class="stripe-spinner hidden" id="stripe-spinner"></div>\n' +
                                        '<span id="stripe-button-text">Subscribe</span>\n' +
                                        '</button>\n' +
                                        '<p class="stripe-result-message hidden">\n' +
                                        'Payment succeeded, see the result in your\n' +
                                        '<a href="" target="_blank">Stripe dashboard.</a> Refresh the page to pay again.\n' +
                                        '</p>\n' +
                                        '</div>' +
                                        '</form>' +
                                        '</div>';

                                    $jQ224("body").append(stripeOverlay);

                                    document.querySelector("#stripe-submit").disabled = true;

                                    $jQ224('#stripe-close').on('click', function (e) {
                                        $jQ224('#stripe-overlay').detach();
                                    });

                                    $jQ224.post(appRoot + '/front_end/purchase/getSetupIntent', postData).then(function (data) {
                                        var stripeElements = stripe.elements();
                                        var style = {
                                            base: {
                                                color: "#32325d",
                                                fontFamily: 'Arial, sans-serif',
                                                fontSmoothing: "antialiased",
                                                fontSize: "16px",
                                                "::placeholder": {}
                                            },
                                            invalid: {
                                                fontFamily: 'Arial, sans-serif',
                                                color: "#fa755a",
                                            }
                                        };

                                        var cardNumberElement = stripeElements.create('cardNumber', {
                                            style: style
                                        });
                                        cardNumberElement.mount('#stripe-card-number-element');

                                        var cardExpiryElement = stripeElements.create('cardExpiry', {
                                            style: style
                                        });
                                        cardExpiryElement.mount('#stripe-card-expiry-element');

                                        var cardCvcElement = stripeElements.create('cardCvc', {
                                            style: style
                                        });
                                        cardCvcElement.mount('#stripe-card-cvc-element');

                                        $jQ224("#stripe-overlay").removeClass("hidden");

                                        var removeErrors = function (event) {
                                            document.querySelector("#stripe-submit").disabled = event.empty;
                                            document.querySelector("#stripe-card-error").classList.add('hidden');
                                            document.querySelector("#stripe-card-error").textContent = event.error ? event.error.message : "";
                                        };

                                        cardNumberElement.addEventListener("change", function (event) {
                                            removeErrors(event);
                                        });

                                        cardExpiryElement.addEventListener("change", function (event) {
                                            removeErrors(event);
                                        });

                                        cardCvcElement.addEventListener("change", function (event) {
                                            removeErrors(event);
                                        });

                                        document.querySelector("#stripe-submit").disabled = false;

                                        var form = document.getElementById("stripe-payment-form");

                                        form.addEventListener("submit", function (event) {
                                            event.preventDefault();
                                            // Complete payment when the submit button is clicked
                                            payWithCard(stripe, cardNumberElement, data.clientSecret);
                                        });
                                    });
                                } else {
                                    stripeHandler.open({
                                        name: $jQ224(this).attr('data-name'),
                                        email: postData.email,
                                        token: function (token) {
                                            postData.gateway_data.stripe_token = token.id;
                                            postFn();
                                        }
                                    });
                                }
                            } else {
                                // Free and PayPal gateways
                                postFn();
                            }
                        }
                    });
                });

                updateProvince = function () {
                    var cIndex = $jQ224('#shippingCountry option:selected').data('id');
                    $jQ224('#shippingProvince').html('<option>--</option>');
                    if (countries[cIndex].provinces.length > 0) {
                        countries[cIndex].provinces.forEach(function (prCurr, pIndex) {
                            $jQ224('#shippingProvince').append('<option value="' + prCurr.code + '">' + prCurr.name + '</option>');
                        });
                    }
                };

                function showGatewayButton(button) {
                    if (button.attr('data-gateway-loaded') == 1) {
                        button.show();
                    } else {
                        button.hide();
                    }
                }
            });
        });
    }
}
